<template>
  <div class="import-offers-container">
    <div class="import-csv-section">
      <div class="import-csv-section-content">
        <mf-button text color="marca-0-l40" :disabled="disabled" label="Importar lista de produtos" icon="cloud_upload" @click="openImportModal = true" />
        <p class="import-csv-label">Somente formato csv</p>
      </div>
    </div>
    <import-dynamic-csv
      v-model="openImportModal"
      title="Importar produtos"
      import-label="Importar lista de produtos"
      load-objects
      :required-any-of="importRequiredAnyOfFields"
      :fields="importFields"
    />
  </div>
</template>

<script>
import flatten from 'lodash/flatten'
import cloneDeep from 'lodash/cloneDeep'

import ImportDynamicCsv from '@/components/ImportDynamicCsv.vue'

import { QUERY_VALIDATE_IMPORTED_PRODUCTS } from '@/modules/campanhas/gestao-ofertas-v2/graphql'

import { mariaCampaign } from '../../../mixins/maria-campaign'
export default {
  name: 'ProductsContainer',
  components: {
    ImportDynamicCsv,
  },
  mixins: [mariaCampaign],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openImportModal: false,
    importRequiredAnyOfFields: ['sku', 'ean'],
    importFields: [
      { text: 'SKU', value: 'sku' },
      { text: 'EAN', value: 'ean' },
      { text: 'Nome', value: 'name' },
      { text: 'Preço 1', value: 'price_1' },
      { text: 'Preço 2', value: 'price_2' },
      { text: 'Mín. CPF', value: 'minimum_per_client' },
      { text: 'Máx. CPF', value: 'maximum_per_client' },
    ],
  }),
  provide: function () {
    return {
      objectSelected: this.formatImportedOffers,
      updateRequiredColumns: () => {},
    }
  },
  computed: {
    products: {
      set(value) {
        this.$store.commit('SET_IMPORTED_PRODUCTS', value)
      },
      get() {
        return this.importedProducts
      },
    },
  },
  methods: {
    async formatImportedOffers({ objects, selectedColumns }) {
      let idField = null
      let ids = []

      if (selectedColumns.includes('sku')) {
        idField = 'sku'
        ids = objects.map(({ sku }) => sku)
      } else if (selectedColumns.includes('ean')) {
        idField = 'ean'
        ids = objects.map(({ ean }) => ean)
      } else {
        this.$alert({
          title: 'Erro na importação',
          message: 'O arquivo importado precisa conter SKU ou EAN',
        })
        return
      }
      ids = ids.filter((item) => item !== '')

      const payload = {}
      payload[`${idField}s`] = ids

      if (this.onlyActive) {
        payload.active = true
      }

      await this.$apollo
        .query({
          query: QUERY_VALIDATE_IMPORTED_PRODUCTS,
          variables: payload,
        })
        .then((response) => {
          this.found = response.data.products.products
          let allValues = []
          this.found.forEach((prod) => {
            allValues = [...allValues, ...flatten(prod.eans), prod.ean, prod.sku]
          })
          this.not_found = ids.filter((item) => {
            return allValues.indexOf(item) === -1
          })
        })
      let confirmed = true
      if (this.not_found.length) {
        confirmed = await this.$confirm({
          message: `Os seguintes ${this.not_found.length} produto(s) não foram encontrados:\n ${this.not_found.join('\n')}
          \n Deseja continuar importação?`,
          confirmText: 'Continuar',
          cancelText: 'Cancelar',
        })
          .then(() => true)
          .catch(() => false)
      }

      if (!confirmed) {
        return
      }

      const checkedProducts = this.found.reduce((acc, product) => {
        objects.forEach((object) => {
          if (product.ean === object[idField] || product.sku === object[idField] || product.eans.indexOf(object[idField]) !== -1) {
            object[idField] = product[idField]
          }
        })
        return { ...acc, [product[idField]]: product }
      }, {})
      const productsToInsert = []
      const insertedIds = []

      objects.forEach((product) => {
        if (checkedProducts[product[idField]]) {
          productsToInsert.push({
            _id: checkedProducts[product[idField]]._id,
            image: checkedProducts[product[idField]].image,
            imported: true,
            active: true,
            price_1: this.formatToPrice(product.price_1),
            price_2: this.formatToPrice(product.price_2),
            additional_points_rate: product.additional_points_rate ? parseInt(product.additional_points_rate.replace(',', '.')) : 0,
            maximum_per_client: product.maximum_per_client ? parseFloat(product.maximum_per_client.replace(',', '.')) : 0,
            minimum_per_client: product.minimum_per_client ? parseFloat(product.minimum_per_client.replace(',', '.')) : 0,
            name: product.name || checkedProducts[product[idField]].name,
            sku: checkedProducts[product[idField]].sku,
            ean: checkedProducts[product[idField]].ean,
            eans: checkedProducts[product[idField]].eans.length === 1 ? [checkedProducts[product[idField]].ean] : checkedProducts[product[idField]].eans,
            original_eans: [],
            product: {
              ean: checkedProducts[product[idField]].ean,
              eans: checkedProducts[product[idField]].eans.length > 1 ? checkedProducts[product[idField]].eans : [checkedProducts[product[idField]].ean],
            },
          })
        }
        insertedIds.push(product[idField])
      })

      let clonedProducts = cloneDeep(this.products)
      const allProducts = clonedProducts.concat(productsToInsert).reduce((products, product) => {
        return products.some((p) => (p.sku && p.sku === product.sku) || (p._id && p._id === product._id)) ? products : [...products, product]
      }, [])

      this.products = allProducts
    },

    formatToPrice(value) {
      if (!value) return 0
      const formattedValue = value.replace(/[R$\s]/g, '').replace(',', '.')
      return parseFloat(formattedValue) || 0
    },
  },
}
</script>

<style lang="scss" scoped>
.import-offers-container {
  display: flex;
  flex-direction: row;
  min-height: 400px;
  .import-csv-section {
    min-height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    .import-csv-section-content {
      max-width: 220px;
      .import-csv-label {
        font-size: 13px;
        color: $cinza-l10;
        text-align: center;
      }
    }
  }
}
</style>
